import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, shareReplay, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IconCacheService {
  private readonly httpClient = inject(HttpClient);
  private readonly cache = new Map<string, Observable<string>>();

  getSvg(name: string): Observable<string> {
    const cached = this.cache.get(name);
    if (cached) {
      return cached;
    }

    const svg$ = this.httpClient.get(`assets/icons/${name}.svg`, { responseType: 'text' }).pipe(
      shareReplay(1),
      catchError((error) => {
        console.error(`Failed to load icon: ${name}`, error);
        this.cache.delete(name);
        return of('');
      }),
    );

    this.cache.set(name, svg$);
    return svg$;
  }

  preloadIcons(names: string[]): void {
    for (const name of names) {
      this.getSvg(name)
        .pipe(take(1))
        .subscribe({
          error: (err) => console.error(`Preload failed for icon: ${name}`, err),
        });
    }
  }
}
